import { Injectable } from '@angular/core'
import { HttpClient, HttpResponse, HttpBackend } from '@angular/common/http'
import { map, Observable } from 'rxjs'

import { environment } from '@env'
import { getHttpHeaders } from '../constants/constants'
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private backend: HttpBackend
  ) {}

  getUserProfileInfo(): Observable<any> {
    return this.http
      .get(`${environment.BASE_URL}/v1/user/profile/info`, {
        headers: getHttpHeaders(),
        observe: 'response',
      })
      .pipe(map((response: HttpResponse<any>) => response.body.data))
  }

  login(credentials: any): Observable<any> {
    let http = new HttpClient(this.backend)
    return http.post(`${environment.BASE_URL}/v1/user/signin`, credentials, {
      headers: getHttpHeaders(),
      observe: 'response',
    })
  }

  registerClient(payload: any): Observable<any> {
    let http = new HttpClient(this.backend)
    return http.post(`${environment.BASE_URL}/v1/register-client`, payload, {
      headers: getHttpHeaders(),
      observe: 'response',
    })
  }

  requestPasswordReset(payload: { email: string }): Observable<any> {
    const http = new HttpClient(this.backend)

    return http.post(
      `${environment.BASE_URL}/v1/auth/request-password-reset`,
      payload,
      {
        observe: 'response',
      }
    )
  }

  verifyResetToken(token: string): Observable<any> {
    const http = new HttpClient(this.backend)

    return http
      .get(`${environment.BASE_URL}/v1/auth/verify-reset-token`, {
        params: { token },
        observe: 'response',
      })
      .pipe(map((response: HttpResponse<any>) => response.body))
  }

  resetPassword(data: {
    token: string
    newPassword: string
    confirmPassword: string
  }): Observable<any> {
    const http = new HttpClient(this.backend)

    return http
      .post(`${environment.BASE_URL}/v1/auth/reset-password`, data, {
        observe: 'response',
      })
      .pipe(map((response: HttpResponse<any>) => response.body))
  }
}
